import http from "./http";

export const getReports = async () => {
  try {
    const res = await http.get("superadmin/reports");
    return res.data;
  } catch (error) {
    return {
      status: false,
      message: error.message,
    };
  }
};